import { render } from "./BasicInfoSection.vue?vue&type=template&id=61589e56&scoped=true"
import script from "./BasicInfoSection.vue?vue&type=script&lang=js"
export * from "./BasicInfoSection.vue?vue&type=script&lang=js"

import "./BasicInfoSection.vue?vue&type=style&index=0&id=61589e56&scoped=true&lang=css"

import exportComponent from "/home/ubuntu/Videos/call-center-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61589e56"]])

export default __exports__